import { Controller } from "@hotwired/stimulus";

// Enables the submit button only when the email input is valid (uses native
// constraint validation, so `type="email" required` defines "valid").
export default class extends Controller {
  static targets = ["input", "submit"];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly submitTarget: HTMLButtonElement;

  connect() {
    this.validate();
  }

  validate() {
    this.submitTarget.disabled = !this.inputTarget.checkValidity();
  }
}
